import { SoldToEffects } from './sold-to.effect';

export const effects: any[] = [SoldToEffects];

export * from './sold-to.effect';
